import { defineComponent as _defineComponent } from 'vue'
import { nextTick, computed, ComputedRef } from "vue"
import store from "@/vue/planning/store/store"
import RadioCircle from "@/vue/common/radioCircle.vue"

// computed
import packagesToDisplay from "@/vue/planning/computed/packagesToDisplay"
import availableNonTransportPackageCodes from "@/vue/planning/computed/availableNonTransportPackageCodes"

// config
import colors from "@/config/colors"


export default /*#__PURE__*/_defineComponent({
  __name: 'transportSwitch',
  setup(__props) {

class SwitchOption {
	label: string
	value: boolean
	constructor(label: string, value: boolean) {
		this.label = label
		this.value = value
	}
}

// computed
const options: ComputedRef<SwitchOption[]> = computed(() => {
	const { content } = store.state
	const switchOptions: SwitchOption[] = []

	switchOptions.push(
		new SwitchOption(content.planner_formulaWithTransport, true)
	)

	// If we have other options besides a train pack, add the switch to select not transport packs
	if (
		availableNonTransportPackageCodes.value &&
		availableNonTransportPackageCodes.value.length
	) {
		switchOptions.push(new SwitchOption(content.planner_noTransport, false))
	}

	return switchOptions
})

// methods
const handleSwitch = (bool: boolean) => {
	store.commit("setTransport", bool)
	nextTick(() => {
		store.dispatch("setPackage", packagesToDisplay.value[0].codePackage)
	})
}

return { __sfc: true,SwitchOption, options, handleSwitch, store, RadioCircle, colors }
}

})